import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useTelegram } from '@/hooks/useTelegram';

const gmMoves = [
  {
    title: 'Используй ход монстра, опасности или локации',
    description: 'У каждого монстра и опасности есть свои ходы. Используй их, когда это уместно.',
    example: 'Дракон использует своё огненное дыхание, заливая пламенем весь коридор.',
  },
  {
    title: 'Покажи признаки надвигающейся угрозы',
    description: 'Намекни на опасность до того, как она ударит. Дай игрокам шанс отреагировать.',
    example: 'Вы слышите тяжёлые шаги и видите тени на стене — что-то большое приближается.',
  },
  {
    title: 'Нанеси урон',
    description: 'Просто и эффективно. Когда монстр атакует — он наносит урон.',
    example: 'Орк обрушивает на тебя топор. Получи d8+2 урона.',
  },
  {
    title: 'Израсходуй их ресурсы',
    description: 'Сломай снаряжение, потрать припасы, израсходуй заклинания.',
    example: 'Твой меч застревает в панцире жука и ломается пополам.',
  },
  {
    title: 'Верни им их ход',
    description: 'Поставь персонажа в ситуацию, где он должен действовать немедленно.',
    example: 'Стрела летит прямо тебе в лицо — что ты делаешь?',
  },
  {
    title: 'Раздели их',
    description: 'Физически разделите группу. Обвал, ловушка, погоня.',
    example: 'Мост рушится, и вы оказываетесь по разные стороны пропасти.',
  },
  {
    title: 'Создай возможность, подходящую классу',
    description: 'Дай возможность персонажу проявить свои уникальные способности.',
    example: 'Вор, ты замечаешь, что замок на двери очень знакомой конструкции...',
  },
  {
    title: 'Покажи обратную сторону их снаряжения',
    description: 'Снаряжение имеет недостатки. Тяжёлая броня гремит, факел привлекает внимание.',
    example: 'Твоя тяжёлая броня грохочет в тишине подземелья. Кто-то это услышал.',
  },
  {
    title: 'Предложи возможность, с ценой или без',
    description: 'Дай выбор: безопасный путь или рискованный, но с наградой.',
    example: 'Вы можете обойти болото за два дня или пройти напрямую за час, но там живут что-то опасное.',
  },
  {
    title: 'Поставь кого-то в сложное положение',
    description: 'НПС или другой персонаж игрока оказывается в беде.',
    example: 'Гоблин хватает заложника и приставляет нож к его горлу.',
  },
  {
    title: 'Расскажи о последствиях или цене и спроси подтверждения',
    description: 'Объясни, что произойдёт, если персонаж продолжит действие.',
    example: 'Ты можешь прыгнуть через пропасть, но если упадёшь — это верная смерть. Прыгаешь?',
  },
];

export function GMMovesPage() {
  const navigate = useNavigate();
  const { hapticFeedback } = useTelegram();

  return (
    <div className="min-h-screen bg-gray-900 safe-area-top safe-area-bottom">
      {/* Header */}
      <div className="sticky top-0 bg-gray-900/95 backdrop-blur-sm border-b border-gray-800 z-10">
        <div className="flex items-center justify-between p-4">
          <button
            onClick={() => {
              hapticFeedback('light');
              navigate('/gm-tools');
            }}
            className="text-gray-400 hover:text-white transition-colors"
          >
            ← Назад
          </button>
          <h1 className="text-lg font-bold text-white">Ходы мастера</h1>
          <div className="w-16" />
        </div>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="p-4 rounded-xl bg-amber-500/10 border border-amber-500/20 mb-6"
        >
          <p className="text-amber-200 text-sm">
            🎲 Делай ход мастера когда: игрок провалил бросок (6-), в повествовании наступила пауза, или игрок дал тебе "золотую возможность".
          </p>
        </motion.div>

        {gmMoves.map((move, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.03 * index }}
            className="p-4 rounded-xl bg-gray-800/50 border border-gray-700/50"
          >
            <h3 className="font-medium text-amber-400 mb-2">{move.title}</h3>
            <p className="text-gray-300 text-sm mb-3">{move.description}</p>
            <div className="p-3 rounded-lg bg-gray-900/50 border-l-2 border-amber-500/50">
              <p className="text-gray-400 text-sm italic">"{move.example}"</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
